class Loader {
  constructor(DOMelement, resultContainer) {
    try {
      this.el = DOMelement;     
    } catch (error) {
      console.log(error);
    }
  }

  show = () => {
    this.el.classList.remove("hide");
    this.el.classList.add("show");
  }

  hide = () => {
    this.el.classList.remove("show");
    this.el.classList.add("hide");
  }
}

export default Loader;